import { ArrowLeft } from "lucide-react";
import Link from "@/components/link";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { BlogContent } from "./BlogContent";
import NotFound from "./NotFound";

interface Post {
  title: string;
  date: string;
  content: string;
}

export default function Blog() {
  const { slug } = useParams<{ slug: string }>();
  const [post, setPost] = useState<Post | null>(null);
  const [status, setStatus] = useState<"loading" | "ok" | "notfound">("loading");

  useEffect(() => {
    let active = true;
    setStatus("loading");
    fetch(`/api/blog/${slug}`)
      .then((res) => {
        if (!res.ok) throw new Error("not found");
        return res.json();
      })
      .then((data: Post) => {
        if (!active) return;
        setPost(data);
        setStatus("ok");
        document.title = data.title;
      })
      .catch(() => {
        if (active) setStatus("notfound");
      });
    return () => {
      active = false;
    };
  }, [slug]);

  if (status === "notfound") return <NotFound />;

  if (status === "loading" || !post) {
    return <main className="min-h-screen bg-white" />;
  }

  return (
    <main className="min-h-screen bg-white flex flex-col">
      <div className="container mx-auto py-8 px-6 md:px-12 lg:px-56 flex-grow">
        <Link
          href="/"
          className="inline-flex items-center text-gray-700 hover:text-gray-900 mb-8"
        >
          <ArrowLeft size={16} className="mr-2" />
          Back to home
        </Link>

        <article className="pr-8 md:pr-28 lg:pr-80">
          <header className="text-left mb-16">
            <h1 className="text-4xl md:text-5xl font-bold mb-2">{post.title}</h1>
            <time className="text-gray-600">{post.date}</time>
          </header>

          <BlogContent content={post.content} />
        </article>
      </div>
    </main>
  );
}
